module.exports = __webpack_public_path__ + "static/contact-banner-58952f056e8e94ac654d8e24ec9207a8.jpg";